import React, { useEffect, useState } from "react"
import { toast } from "sonner"
import { DeleteRequest, GetRequest } from "../../Utils/hooks/ApiHandler"
import { EditContactOffcanvas } from "../../CommonComponents/EditContactOffcanvas"
import DeleteModal from "../DeleteModal"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
// Lucide React Icons
import { CardSkeleton } from "./contactSkeleton/CardSkeleton"
import { ContactCardListing } from "./ContactModule/ContactCardListing"
import { ContactTableListing } from "./ContactModule/ContactTableListing"

export const ContactListing = ({
  isInitialized,
  allContactData,
  data,
  queryKey,
  isLoading,
  setOffset,
  offset,
  columns,
  headers,
  currView,
  limit,
  setLimit,
  totalContacts,
  visibleColumns,
  refetch,
  filterData,
}) => {

  const [customer, setCustomer] = useLocalStorageState("customer")
  const navigate = useNavigate()

  // delete modal loading state
  const [loading, setLoading] = useState(false)

  const [isOwnerSame, setIsOwnerSame] = useState(false)

  // edit dropdown state for each card
  const [activeCard, setActiveCard] = useState(null)

  // confirm delete
  const [confirmDeleteId, setConfirmDeleteId] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  // for offcanvas edit
  const [showId, setShowId] = useState(null)
  const [showOffcanvas, setShowOffcanvas] = useState(false)

  const [contact_data, setContactData] = useState(null)
  const [temData, setTemData] = useState([])

  const [contactId, setContactId] = useState("")

  // Determine the data to display based on filterData
  const dataToDisplay = filterData !== null ? filterData.data : data
  const hasDataToDisplay = dataToDisplay?.length > 0

  const isFiltered = filterData !== null
  const totalItems = isFiltered ? filterData?.total_count : totalContacts

  // Calculate total pages
  const pageCount = Math.ceil(totalContacts / limit) || 0
  const effectivePageCount = isFiltered
    ? Math.ceil((filterData?.total_count || 0) / limit) || 0
    : pageCount

  const currPageItems = dataToDisplay?.length
  const displayStartItem = totalItems === 0
    ? 0
    : offset * limit + 1
  const displayEndItem = totalItems === 0
    ? 0
    : Math.min(offset * limit + limit, totalItems)

  // if error while fetching contact
  const [showContactDetailsCanvas, setShowContactDetailsCanvas] = useState(false)

  // outside click handler
  useEffect(() => {
    const handler = (event) => {
      const isDropdown = event.target.closest("[data-dropdown]")
      const isOptionsButton = event.target.closest("[data-options-button]")
      if (!isDropdown && !isOptionsButton) {
        setActiveCard(null)
      }
    }
    document.addEventListener("click", handler)
    return () => {
      document.removeEventListener("click", handler)
    }
  }, [])

  // delete contact handler
  const handleDeleteContact = async (contact_id) => {
    setLoading(true)
    try {
      if (!contact_id) return;
      const res = await DeleteRequest(
        `contacts/deleteContact/${contact_id}/${customer?.customer_details?.id}/${customer?.customer_details?.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.success === false) {
        setLoading(false)
        setShowDeleteModal(false)
        toast.error(res.message)
        return
      }
      if (res.status === "fail") {
        setLoading(false)
        setShowDeleteModal(false)
        toast.warning(res.message)
        return
      }
      refetch()
      setLoading(false)
      // Predict the new total contacts and page count after deletion
      const newTotalContactsAfterDeletion = totalContacts - 1;
      const newPageCountAfterDeletion = Math.ceil(
        newTotalContactsAfterDeletion / limit
      );
      // If the current offset is now beyond the new last page, adjust it
      if (
        offset >= newPageCountAfterDeletion &&
        newPageCountAfterDeletion > 0
      ) {
        setOffset(newPageCountAfterDeletion - 1);
      } else if (newPageCountAfterDeletion === 0) {
        // If all items are deleted, reset offset to 0
        setOffset(0);
      }
      toast.success(res.message);
    } catch (error) {
      toast.error("Internal Server Error");
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
    }
  };

  // fetch contact details useEffect
  useEffect(() => {
    if (showId === null) return
      ; (async () => {
        const res = await GetRequest(
          `contacts/getContactDetailsById/${showId}`,
          { headers },
          { customer, setCustomer, rf: headers.Authentication, navigate },
        )
        if (res.err === false || res.status === "fail") {
          // toast.error("Error fetching data!")
          return
        }
        const parsedVis = JSON.parse(res?.data[0]?.visible_to)

        // if (
        //   customer?.customer_details?.id === res?.data[0]?.owner_id &&
        //   customer?.customer_details?.user_type === "1"
        // ) {
        //   setIsOwnerSame(true)
        // } else {
        //   setIsOwnerSame(false)
        // }

        if (
          customer?.customer_details?.user_type === "1"
        ) {
          setIsOwnerSame(true)
        } else if (customer?.customer_details?.id === res?.data[0]?.owner_id) {
          setIsOwnerSame(true)
        } else {
          setIsOwnerSame(false)
        }

        setTemData(parsedVis)
        setContactData(res.data[0])
        setShowOffcanvas(true)
      })()
  }, [showId])

  //   handleClose for closing the canvas
  const handleCanvasClose = () => {
    setShowContactDetailsCanvas(false)
  }

  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected)
  }

  // Reset offset when filtered data shrinks
  if (isFiltered && offset !== 0 && dataToDisplay?.length === 0) {
    setOffset(0)
  }

  return (
    // <div className="d-flex flex-column " style={{ marginBottom: "1rem" }}>
    <>
      {
        isLoading && !isInitialized ? (
          // Show skeleton while loading
          <>
            {
              currView === "card" && <CardSkeleton />
            }
          </>
        ) : (
          <>
            {currView === "card" ?
              <ContactCardListing
                hasDataToDisplay={hasDataToDisplay}
                dataToDisplay={dataToDisplay}
                effectivePageCount={effectivePageCount}
                displayEndItem={displayStartItem}
                totalItems={totalItems}
                handlePageChange={handlePageChange}
                offset={offset}
                setOffset={setOffset}
                setActiveCard={setActiveCard}
                setConfirmDeleteId={setConfirmDeleteId}
                // setContactId={setContactId}
                // setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                setShowId={setShowId}
                setShowDeleteModal={setShowDeleteModal}
                setLimit={setLimit}
                handleDeleteContact={handleDeleteContact}
              />
              : (
                // list view
                <ContactTableListing
                  isLoading={isLoading}
                  hasDataToDisplay={hasDataToDisplay}
                  dataToDisplay={dataToDisplay}
                  handlePageChange={handlePageChange}
                  columns={columns}
                  // setContactId={setContactId}
                  // setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                  setConfirmDeleteId={setConfirmDeleteId}
                  setShowDeleteModal={setShowDeleteModal}
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  totalItems={totalItems}
                  displayStartItem={displayStartItem}
                  displayEndItem={displayEndItem}
                  effectivePageCount={effectivePageCount}
                  setShowId={setShowId}
                  currPageItems={currPageItems}
                />
              )}
          </>
        )
      }
      {/* {
        showContactDetailsCanvas && contactId && (
          <ContactDetails
            show={showContactDetailsCanvas}
            setShowContactDetailsCanvas={setShowContactDetailsCanvas}
            onCanvasClose={handleCanvasClose}
            id={contactId}
            allContacts={data}
          />
        )
      } */}
      {
        showDeleteModal && (
          <DeleteModal
            onConfirm={() => {
              handleDeleteContact(confirmDeleteId)
              setConfirmDeleteId(null)
            }}
            onClose={() => {
              setConfirmDeleteId(null)
              setShowDeleteModal(false)
            }}
            contactId={confirmDeleteId}
            show={true}
            isLoading={loading}
            message="Are you sure you want to delete this followup?"
          />
        )
      }
      {/* Move EditContactOffcanvas outside of the main layout structure */}
      {
        showId !== null && contact_data && (
          <EditContactOffcanvas
            queryKey={queryKey}
            isOwnerSame={isOwnerSame}
            allContacts={allContactData}
            show={showOffcanvas}
            contactId={showId}
            setShow={setShowOffcanvas}
            contact_data={contact_data}
            setContactData={setContactData}
            temData={temData}
            refetch={refetch}
            onHide={() => {
              setShowId(null)
            }}
          />
        )
      }
    </ >
  )
}
